<!-- src/components/Header.vue -->
<template>
  <header>
    <nav>
      <ul class="button-list">
        <li><router-link class="button-link" to="/pidtracking">PID Tracking</router-link></li>
        <li><router-link class="button-link" to="/vmtracking">VM Tracking</router-link></li>
        <li><router-link class="button-link" to="/stoptracking">Stop Data</router-link></li>
        <li><router-link class="button-link" to="/livecontrol">Live Control</router-link></li>
      </ul>
      <span v-if="timeRemaining" class="timer">Session: {{ timeRemaining }}</span>
      <span class="version">v{{ version }}</span>
    </nav>
  </header>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  setup() {
    const version = process.env.VUE_APP_VERSION
    const timeRemaining = ref('');
    let timerInterval = null;

    const updateTimer = () => {
      const token = localStorage.getItem('jwtToken');
      if (!token) {
        timeRemaining.value = '';
        return;
      }

      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const exp = payload.exp * 1000;
        const now = Date.now();
        const diff = exp - now;

        if (diff <= 0) {
          timeRemaining.value = 'Expired';
          return;
        }

        const minutes = Math.floor(diff / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);
        timeRemaining.value = `${minutes}:${seconds.toString().padStart(2, '0')}`;
      } catch (e) {
        timeRemaining.value = '';
      }
    };

    onMounted(() => {
      updateTimer();
      timerInterval = setInterval(updateTimer, 1000);
    });

    onUnmounted(() => {
      if (timerInterval) clearInterval(timerInterval);
    });

    return { version, timeRemaining };
  },
};
</script>

<style scoped>
.button-list {
  display: flex;
  list-style: none;
  padding: 10;
  margin: 10;
}

.button-link {
  padding: 10px 20px;
  margin-right: 10px;
  background-color: #007bff;
  color: white;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  transition: background-color 0.3s;
}

.button-link:hover {
  background-color: #0056b3;
}

nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.version {
  margin-right: 20px;
  font-weight: bold;
  color: #555;
}

.timer {
  margin-right: 20px;
  font-weight: bold;
  color: #d9534f;
  /* Red-ish color to indicate urgency/status */
}
</style>